import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router
} from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { AuthService, UserHttpService } from '../../services';
import { Roles } from '../enums/roles';

@Injectable({
  providedIn: 'root'
})
export class AccountAccessGuard implements CanActivate {

    private authService= inject(AuthService);
    private router = inject(Router);
    private userService = inject(UserHttpService);

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeUserId = route.params['id'];
    const currentUser = this.authService.currentUserValue;
        
    if(currentUser.role === Roles.Administrator)
    {
        return this.userService.getUserById(routeUserId).pipe(
            map( user => {
                if(user)
                    return true;
            this.router.navigate(['**']);
            return false;
            })
        );
    }
    
    if (routeUserId === currentUser.userId.toString())
    {
        return of(true);
    }

    this.router.navigate(['/']);
    return of(false);
    }
}